import * as _ from 'lodash';
import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {ShipmentRoute, ShipmentRouteJSON} from './shipment-route';
import {HttpClient} from '@angular/common/http';
import {AuthService, BaseService} from '@hassel-it/angular-common';
import {Shipment} from "./shipment";

@Injectable()
export class ShipmentRoutesService extends BaseService {

    private token = 'sk.eyJ1IjoicGFydG5lcml0IiwiYSI6ImNrNW80ZDY5NTAyMHQza3BpdXllcW43MTcifQ.g85OSjAcyQ1dbcj-Ytacug';

    constructor(public http: HttpClient, public authService: AuthService) {
        super(http, authService);
    }

    getShipmentRoutes(): Promise<ShipmentRoute[]> {
        this.reloadHeaders();
        return this.http.get(environment.apiBase + '/api/ten-four/shipment_routes', {
            headers: this.httpHeaders
        }).toPromise().then((response: any) => {
            return _.chain(response.data).map((json: ShipmentRouteJSON): ShipmentRoute => {
                return ShipmentRoute.fromJSON(json)
            }).value();
        }).catch(ShipmentRoutesService.handleError);
    }

    getShipmentRoute(shipmentRouteId: string): Promise<ShipmentRoute> {
        return this.http.get(environment.apiBase + '/api/ten-four/shipment_routes/' + shipmentRouteId, {
            headers: this.httpHeaders
        }).toPromise().then((response: any) => {
            return ShipmentRoute.fromJSON(response.data);
        }).catch(ShipmentRoutesService.handleError);
    }


    addShipmentRoute(shipmentRoute: ShipmentRoute): Promise<ShipmentRoute> {
        this.reloadHeaders();

        return this.http.post(environment.apiBase + '/api/ten-four/shipment_routes', shipmentRoute, {
            headers: this.httpHeaders
        }).toPromise().then((response: any) => {
            return response.data as ShipmentRoute;
        }).catch(ShipmentRoutesService.handleError);
    }

    updateShipmentRoute(shipmentRoute: ShipmentRoute): Promise<ShipmentRoute> {
        this.reloadHeaders();

        return this.http.patch(environment.apiBase + '/api/ten-four/shipment_routes/' + shipmentRoute.id, shipmentRoute, {
            headers: this.httpHeaders
        }).toPromise().then((response: any) => {
            return response.data as ShipmentRoute;
        }).catch(ShipmentRoutesService.handleError);
    }

    deleteShipmentRoute(shipmentRoute: ShipmentRoute): Promise<boolean> {
        this.reloadHeaders();

        return this.http.delete(environment.apiBase + '/api/ten-four/shipment_routes/' + shipmentRoute.id, {
            headers: this.httpHeaders
        }).toPromise().then((response: any) => {
            return true;
        }).catch(ShipmentRoutesService.handleError);
    }




    optimizeRoutes(shipments, branch): Promise<any> {
        const coords = this.createCoordsArray(shipments, branch);

        const url = 'https://api.mapbox.com/optimized-trips/v1/mapbox/driving/' + coords.join(';') + '?access_token=' + this.token;

        return this.http.get(url).toPromise().then((response: any) => {
            return response;
        }).catch(ShipmentRoutesService.handleError);
    }

    getRoute(shipments, branch) {
        const coords = this.createCoordsArray(shipments, branch);

        const url = 'https://api.mapbox.com/directions/v5/mapbox/driving/' + coords.join(';') + '?access_token=' + this.token + '&geometries=geojson&overview=full&exclude=ferry'

        return this.http.get(url).toPromise().then((response: any) => {
            return response;
        }).catch(ShipmentRoutesService.handleError);
    }

    protected createCoordsArray(shipments, branch) {
        const coords = [];

        coords.push(this.getBranchCoords(branch));

        for (const shipment of shipments) {
            coords.push(shipment.shipment_address.x + ',' + shipment.shipment_address.y)
        }

        coords.push(this.getBranchCoords(branch));

        return coords;
    }

    public getBranchCoords(branch) {
        switch (branch) {
            case 'hoe':
                return '10.046381,56.0883943';

            case 'rin':
                return '8.24072235,56.09178116';

            case 'ulf':
                return '8.32279779,56.26230378';

            case 'var':
                return '8.49911157,55.60273122';

            case 'vib':
                return '9.39733139,56.46424435';

            case 'vid':
                return '8.63984684,56.09081367';
            case 'cla':
                return '8.24072235,56.09178116';
        }
    }

    public getBranchShipment(shipmentRoute: ShipmentRoute): Shipment {
        const branch = this.getBranchCoords(shipmentRoute.branch).split(',').map(Number);
        return Shipment.fromJSON({
            shipment_status_formatted: 'Ukendt',
            id: null,
            branch: shipmentRoute.branch,
            shipment_route_id: shipmentRoute.id,
            shipment_route: shipmentRoute,
            shipment_address: {x: branch[0], y: branch[1], adress_1_receiver: '10-4'},
            map_x: branch[0],
            map_y: branch[1],
        });

    }
}
